// extracted by mini-css-extract-plugin
export default {"alert":"FormAlert_alert__VfNQD","danger":"FormAlert_danger__u6COL","success":"FormAlert_success__4VwF6","icon":"FormAlert_icon__mpTnV","text":"FormAlert_text__58wul"};